module.exports = __webpack_public_path__ + "1f943ffbc94b51da35d67b056ab2f5f5.png";